import tunnels from '@/http/requests/tunnels';
import axios from '../../http/axios'

export default {
  fetchTunnels({ commit }, light) {
    return new Promise((resolve, reject) => {
      tunnels
        .getTunnels(light)
        .then(response => {
          commit('SET_TUNNELS', response.data)
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  fetchTunnel({ commit }, tunnelId) {
    return new Promise((resolve, reject) => {
      tunnels
        .getTunnel(tunnelId)
        .then(response => {
          if (response.data) {
            commit('ADD_TUNNEL', response.data)
            resolve(response.data)
          } else {
            reject(response.data.error)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  fetchTunnelSetupScript({ commit }, tunnelId) {
    return new Promise((resolve, reject) => {
      tunnels
        .getTunnelSetupScript(tunnelId)
        .then(response => {
          if (response.data.data) {
            commit('ADD_TUNNEL_SETUP_SCRIPT', response.data.data)
            resolve(response.data.data)
          } else {
            reject(response.data.error)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  addTunnel({ commit }, { tunnel }) {
    return new Promise((resolve, reject) => {
      tunnels
        .addTunnel(tunnel)
        .then(response => {
          if (response.data.data) {
            commit('ADD_TUNNEL', response.data.data)
            resolve(response.data.data)
          } else {
            reject(response.data.error)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updateTunnel({ commit }, { tunnel, tunnelId }) {
    return new Promise((resolve, reject) => {
      tunnels
        .updateTunnel(tunnel, tunnelId)
        .then(response => {
          if (response.data.data) {
            commit('ADD_TUNNEL', response.data.data)
            resolve(response.data.data)
          } else {
            reject(response.data.error)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  deleteTunnel({ commit }, { tunnelId }) {
    return new Promise((resolve, reject) => {
      tunnels
        .deleteTunnel(tunnelId)
        .then(response => {
          if (response.data) {
            commit('ADD_TUNNEL', null)
            resolve(response.data.message)
          } else {
            reject(response.error)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getTunnelBindPort({ commit }) {
    return new Promise((resolve, reject) => {
      tunnels
        .getTunnelBindPort()
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getTunnelLocations({ commit }) {
    return new Promise((resolve, reject) => {
      tunnels
        .getTunnelLocations()
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  setActiveTunnel({ commit }, tunnel) {
    commit('SET_ACTIVE_TUNNEL', tunnel)
  },
  getTunnelAnalytics({ commit }, { tunnelId, type, period, points }) {
    return new Promise((resolve, reject) => {
      tunnels
        .getTunnelAnalytics(tunnelId, type, period, points || 720)
        .then(response => {
          if (response.data) {
            resolve(response.data)
          } else {
            reject(response.data.error)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getTunnelFilters({ commit }) {
    return new Promise((resolve, reject) => {
      tunnels
        .getTunnelFilters()
        .then(response => {
          if (response.data) {
            commit('SET_FILTERS', response.data)
            resolve(response.data)
          } else {
            reject(response.data.error)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  addTunnelFirewall({ commit }, { tunnelId, firewall }) {
    return new Promise((resolve, reject) => {
      tunnels
        .addTunnelFirewall(tunnelId, firewall)
        .then(response => {
          if (response.data.data) {
            commit('ADD_FIREWALL', response.data.data)
            resolve(response.data.data)
          } else {
            reject(response.data.error)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getTunnelFirewalls({ commit }, tunnelId) {
    return new Promise((resolve, reject) => {
      tunnels
        .getTunnelFirewalls(tunnelId)
        .then(response => {
          if (response.data) {
            commit('SET_FIREWALLS', response.data)
            resolve(response.data)
          } else {
            reject(response.data.error)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  deleteTunnelFirewall({ commit }, { filterId }) {
    return new Promise((resolve, reject) => {
      tunnels
        .deleteTunnelFirewall(filterId)
        .then(response => {
          if (response.data) {
            commit('ADD_FIREWALL', null)
            resolve(response.data.message)
          } else {
            reject(response.error)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updateTunnelFirewall({ commit }, { firewall, filterId }) {
    return new Promise((resolve, reject) => {
      tunnels
        .updateTunnelFirewall(firewall, filterId)
        .then(response => {
          if (response.data.data) {
            commit('ADD_FIREWALL', response.data.data)
            resolve(response.data.data)
          } else {
            reject(response.data.error)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getTunnelFirewall({ commit }, filterId) {
    return new Promise((resolve, reject) => {
      tunnels
        .getTunnelFirewall(filterId)
        .then(response => {
          if (response.data) {
            commit('ADD_FIREWALL', response.data)
            resolve(response.data)
          } else {
            reject(response.data.error)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}
